


export function SetActiveTab(tabGroupId: string, activeTabId: string): void {

    //console.log("SetActiveTab", tabGroupId, activeTabId);

    $('#' + tabGroupId + ' .tab-pane').removeClass('show active');
    $('#' + activeTabId).addClass('show active');

}